<!-- 文章详情 -->
<template>
  <div class="document-details">
    <div class="breadcrumb flex" @click="onBreadcrumbItem">
      <b>当前位置:</b>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span> {{ $route.query.title }}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span> {{ $route.query.tag }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="pervasive-card details" :loading="loading">
      <div class="article-content">
        <h2 class="my-title">{{ details.title }}</h2>
        <div class="department">
          <span>
            <i v-if="details.department" class="el-icon-office-building"></i>
            {{ details.department }}
          </span>
          <span>
            <i v-if="details.author" class="el-icon-user"></i>
            {{ details.author }}
          </span>
          <span>
            <i v-if="details.publishedDate" class="el-icon-time"></i>
            {{
              details.publishedDate ? details.publishedDate.split(' ')[0] : ''
            }}
          </span>
        </div>
        <div v-html="details.newContent"></div>
      </div>
      <template v-if="details.attachmentList">
        <div
          class="download-document flex"
          v-for="(item, i) in details.attachmentList"
          :key="i"
        >
          <i class="el-icon-paperclip"> </i>
          <a
            class="itemName text_overflow"
            :href="path + item.path"
            :download="'/' + item.name"
            >{{ item.name }}</a
          >
          <i
            class="el-icon-view"
            @click="opendialog(path + item.path)"
            v-if="str.includes(item.name.split('.')[1])"
          ></i>
          <a
            class="el-icon-download"
            :href="path + item.path"
            :target="str.includes(item.name.split('.')[1]) ? '_blank' : ''"
            :download="'/' + item.name"
          >
          </a>
        </div>
      </template>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%" fullscreen>
      <embed
        :src="pdfurl"
        width="100%"
        height="100%"
        type="application/pdf"
        v-if="pdfurl.includes('.pdf')"
      />
      <img :src="pdfurl" alt="" v-else />
    </el-dialog>
  </div>
</template>
<script>
import { getArticleDetails } from '@/api/index'

export default {
  name: '',
  props: [],
  components: {},
  data() {
    return {
      loading: false,
      details: '',
      str: ['jpg', 'png', 'jpeg', 'pdf'],
      dialogVisible: false,
      path: process.env.VUE_APP_BASE_API,
      pdfurl: ''
    }
  },
  watch: {},
  methods: {
    opendialog(url) {
      this.pdfurl = url
      this.dialogVisible = true
    },
    insertTextByPattern(originalString, pattern, textToInsert) {
      // 使用正则表达式的捕获组来确定插入位置
      return originalString.replace(pattern, `$&${textToInsert}`)
    },
    getArticleDetails() {
      this.loading = true
      getArticleDetails(this.$route.query.id)
        .then((res) => {
          this.details = res
          const result = this.insertTextByPattern(
            res.content,
            /="video"/g,
            'style="display: flex;justify-content: center;margin: 16px 0"'
          )
          this.details['newContent'] = result
        })
        .finally(() => {
          this.loading = false
        })
    },
    onBreadcrumbItem() {
      this.$router.go(-1)
    }
  },

  mounted() {
    this.getArticleDetails()
  },
  created() {}
}
</script>

<style lang="scss" scope>
.document-details {
  width: 100%;
  flex: 1;
  background-size: cover !important;
  .breadcrumb {
    margin: 16px 0;
    align-items: center;
    &:hover {
      span,
      i {
        font-weight: 800;
        color: #000;
      }
    }
    span {
      cursor: pointer;
      font-size: 18px;
    }
    b {
      margin-right: 10px;
    }
  }
  .el-breadcrumb__inner {
    font-weight: 400;
    color: #606266;
    cursor: text;
  }
  .details {
    padding: 24px 40px;
    margin-bottom: 40px;
    .my-title {
      text-align: center;
    }
    .department {
      text-align: center;
      margin: 14px auto 18px;
      padding-bottom: 16px;
      border-bottom: 1px solid #dcdfe6;
      span {
        color: #888888;
        line-height: 22px;
        margin-right: 14px;
      }
    }
    span {
      line-height: 22px;
      color: #333;
    }
    img {
      margin: 10px auto;
      max-width: 100%;
    }
    video {
      max-width: 100%;
    }
    p {
      margin: 10px 0;
      line-height: 2;
    }
  }

  .download-document {
    color: #2381d4;
    align-items: center;
    margin-bottom: 12px;
    width: auto;

    .itemName {
      display: inline-block;
      margin: 0 12px;
      width: auto;
      color: #2381d4;
    }
    .el-icon-paperclip {
      cursor: pointer;
      &::before {
        color: #2381d4;
      }
    }

    .el-icon-view,
    .el-icon-download {
      padding: 4px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      margin-right: 10px;
      transition: all 0.3s;

      &:hover {
        background-color: #2381d410;
        transform: scale(1.01);
      }
      &::before {
        color: #2381d4;
      }
    }
  }
  .el-dialog__body {
    height: 100vh;
    padding: 0;
    background: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin: 0 auto;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 130px;
    .el-dialog__close {
      color: #fff;
    }
  }
  .article-content {
    /* 表格样式 */
    table {
      border-collapse: collapse;
      width: 100%;
      margin: 10px 0;
      border: 1px solid #808284;
    }
    
    table th,
    table td {
      border: 1px solid #808284;
      padding: 8px;
      text-align: left;
    }
    
    table th {
      background-color: #f5f7fa;
      font-weight: bold;
    }
  }
}
@media screen and (max-width: 768px) {
  .document-details {
    .breadcrumb {
      b {
        font-size: 14px;
      }
      span {
        font-size: 14px;
      }
    }
    .details {
      padding: 24px 14px;
      width: 100%;

      .department {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
      span {
        line-height: 22px;
        color: #333;
      }
      img {
        margin: 10px auto;
        width: 100% !important;
        max-width: min-content !important;
      }
      video {
        width: 100% !important;
        max-width: 100%;
      }
      p {
        margin: 10px 0;
        width: 100%;
        text-indent: 0 !important;
      }
    }
  }
}
</style>
